import api from './api';

export const getMyLeaves = (params) => api.get('/v1/leaves/my', { params });
export const getPendingLeaves = (params) => api.get('/v1/leaves/pending', { params });
export const getLeave = (id) => api.get(`/v1/leaves/${id}`);
export const validateLeave = (data) => api.post('/v1/leaves/validate', data);
export const createLeave = (data) => api.post('/v1/leaves', data);
export const cancelLeave = (id) => api.put(`/v1/leaves/${id}/cancel`);
export const approveLeave = (id) => api.put(`/v1/leaves/${id}/approve`);
export const rejectLeave = (id, data) => api.put(`/v1/leaves/${id}/reject`, data);
// signatureStatus: "signed" | "unsigned"
export const setSignatureStatus = (id, signatureStatus) =>
  api.put(`/v1/leaves/${id}/signature`, { signatureStatus });
